export const versionPillars = [
  {
    icon: "ri-film-line",
    title: "中文字幕版",
    subtitle: "原声 + 中文字幕",
    desc: "以原始音轨为主，配合中文对白文本呈现。适合希望保留原声语气、环境音与配乐层次的观众。",
    points: ["保留原始对白与音效", "字幕随画面对应出现", "可自由开关字幕轨道"],
  },
  {
    icon: "ri-mic-line",
    title: "国语版（中文配音）",
    subtitle: "中文重新配音",
    desc: "由配音员以中文重新录制对白并替换原始人声，观看时基本无需阅读字幕，注意力更集中在画面上。",
    points: ["无需持续读字幕", "适合边做事边看", "对白以中文直接表达"],
  },
  {
    icon: "ri-play-circle-line",
    title: "字幕在线",
    subtitle: "与播放同步",
    desc: "字幕在播放过程中同步载入并显示，通常可切换语言轨道、调整字号与位置，方便按需查看。",
    points: ["随播放实时呈现", "可切换语言轨道", "支持字号与位置调整"],
  },
  {
    icon: "ri-chat-voice-line",
    title: "普通话",
    subtitle: "配音常用语言标准",
    desc: "中文配音常用的语言标准之一，用词与发音相对规范统一，是判断版本是否便于听懂的重要线索。",
    points: ["发音规范便于听懂", "常见于国语配音版本", "与方言配音相区分"],
  },
];

export const glossaryTerms = [
  {
    term: "中文字幕",
    short: "中字",
    definition: "以中文呈现的对白文本，通常叠加在画面上方或下方，配合原始音轨一起观看。",
    detail:
      "中文字幕解决的是“听不懂原声”的问题。它保留原始台词的语气和节奏，只在视觉层补充中文意思，因此在画面干净、字幕清晰时体验最好。",
    example: "常见标注：中文字幕、内嵌中字、中文外挂字幕。",
  },
  {
    term: "国语版",
    short: "国语",
    definition: "指采用国语的版本，在实际使用中通常指中文配音，而非保留原始对白。",
    detail:
      "看到“国语版”时，一般可以理解为对白已被替换为中文配音。它和“中文字幕”的关键区别在于：一个是听，一个是看，二者可以单独存在也可以同时提供。",
    example: "常见标注：国语版、国语配音、国语中字。",
  },
  {
    term: "中文配音",
    short: "配音",
    definition: "由配音员以中文重新录制对白，用来替代作品的原始人声轨道。",
    detail:
      "中文配音让观众不必依赖字幕即可理解对白，适合多任务、环境嘈杂或视力不便的场景。不同配音版本的用词与语气可能有差异，属于正常的版本区别。",
    example: "常见标注：中文配音、普通话配音、国语配音。",
  },
  {
    term: "字幕在线",
    short: "在线字幕",
    definition: "字幕在播放过程中在线加载并同步显示，而非预先嵌入画面。",
    detail:
      "字幕在线的好处是可按需切换与关闭，并常支持字号、颜色、位置等显示设置；限制在于加载与时间轴是否对齐，取决于来源质量。",
    example: "常见标注：字幕在线、在线中文字幕、可切换字幕轨道。",
  },
  {
    term: "中字",
    short: "中字",
    definition: "“中文字幕”的简称，多出现在标题、标签或简介中，用来强调提供中文字幕。",
    detail:
      "“中字”只是一个标注习惯，并不说明字幕是内嵌还是外挂，也不说明是否为官方字幕。看到这一标注后，通常还需进一步确认字幕形式与版本是否匹配。",
    example: "常见标注：中字、中文字幕、中英字幕。",
  },
  {
    term: "普通话",
    short: "普通话",
    definition: "中文配音常用的语言标准之一，发音与用词相对规范统一。",
    detail:
      "普通话常作为判断“是否便于听懂”的线索。标注普通话的版本，一般对白表达能力更统一；具体用词仍会因配音团队不同而存在差异。",
    example: "常见标注：普通话、普通话配音、普通话版。",
  },
];

export const compareColumns = ["对比项", "原声＋中文字幕", "国语版（中文配音）"];

export const compareRows = [
  { item: "对白声音", original: "保留原始音轨与语气", dubbed: "中文人声重新录制" },
  { item: "是否需读字幕", original: "需要持续阅读", dubbed: "一般不需读字幕" },
  { item: "注意力分配", original: "画面与字幕兼顾", dubbed: "更集中在画面" },
  { item: "适合场景", original: "安静环境专注观看", dubbed: "多任务或不便看屏幕" },
  { item: "语言门槛", original: "需一定阅读速度", dubbed: "听懂即可理解" },
  { item: "常见标签", original: "中字、中文字幕、字幕在线", dubbed: "国语版、中文配音、普通话" },
];

export const filterOptions = ["全部", "中文字幕", "国语配音", "字幕在线", "普通话"];

export const versionEntries = [
  {
    id: "v1",
    title: "内嵌中文字幕版本",
    tags: ["中文字幕"],
    format: "字幕形式：内嵌",
    desc: "中文对白固定在画面中，随视频一起呈现，不依赖单独的播放器设置。",
    suitable: "适合设备或播放器不支持外挂字幕时使用。",
  },
  {
    id: "v2",
    title: "外挂中文字幕文件",
    tags: ["中文字幕"],
    format: "字幕形式：外挂文件",
    desc: "字幕以独立文件形式提供，由播放器加载，可自行调整字号、颜色与位置。",
    suitable: "适合希望自定义字幕显示效果的观众。",
  },
  {
    id: "v3",
    title: "字幕在线切换版本",
    tags: ["中文字幕", "字幕在线"],
    format: "字幕形式：在线加载",
    desc: "字幕在播放过程中同步载入，可切换语言轨道并即时开关，无需额外文件。",
    suitable: "适合临时观看或不想单独管理字幕文件的场景。",
  },
  {
    id: "v4",
    title: "普通话国语配音版本",
    tags: ["国语配音", "普通话"],
    format: "音轨形式：中文配音",
    desc: "对白以普通话配音替换原始人声，观看时不依赖字幕即可跟随剧情。",
    suitable: "适合不便阅读字幕或多任务观看时使用。",
  },
  {
    id: "v5",
    title: "双语对照字幕版本",
    tags: ["中文字幕", "字幕在线"],
    format: "字幕形式：中英对照",
    desc: "中文与另一语言上下对照呈现，便于同时理解中文表达与原文用词。",
    suitable: "适合希望核对台词或学习语言的观众。",
  },
  {
    id: "v6",
    title: "原声 + 普通话字幕标注",
    tags: ["中文字幕", "普通话"],
    format: "字幕形式：普通话用字标注",
    desc: "保留原始对白，字幕以规范的中文用字呈现，便于快速阅读与理解。",
    suitable: "适合既想保留原声又希望字幕规范的观众。",
  },
];

export const checklist = [
  {
    icon: "ri-volume-up-line",
    title: "先确认音轨语言",
    desc: "播放前先看清是原声还是国语配音，避免在观看中途才发现与预期不符。",
  },
  {
    icon: "ri-file-text-line",
    title: "确认字幕形式",
    desc: "区分内嵌、外挂与字幕在线，三种形式在可调整程度上差别较大。",
  },
  {
    icon: "ri-movie-2-line",
    title: "核对音画是否同版",
    desc: "字幕与时轴需要对应同一版本，否则容易出现对白与画面错位的情况。",
  },
  {
    icon: "ri-time-line",
    title: "留意时间轴对齐",
    desc: "外挂字幕若出现提前或延迟，可在播放器中微调字幕延迟以恢复正常节奏。",
  },
  {
    icon: "ri-headphone-line",
    title: "选择合适收听环境",
    desc: "佩戴耳机或使用安静环境观看，更利于分辨配音细节与背景音层次。",
  },
];

export const faqs = [
  {
    q: "中文字幕和国语版有什么区别？",
    a: "中文字幕是在画面上补充中文对白，原始声音不变；国语版通常指对白被替换为中文配音。前者需要阅读，后者只需听懂，两者可以单独提供，也可能同时存在。",
  },
  {
    q: "字幕在线和外挂字幕有什么不同？",
    a: "字幕在线是在播放过程中同步加载，通常可直接切换与开关；外挂字幕则是独立文件，由播放器手动载入。两者都不改变画面，区别主要在加载方式与可调整程度。",
  },
  {
    q: "标注“中字”一定说明字幕形式吗？",
    a: "不一定。“中字”只是中文字幕的简称，通常只表示提供中文对白文本，并不会说明是内嵌、外挂还是在线字幕，具体形式需要进一步确认。",
  },
  {
    q: "普通话配音和原声该怎么选？",
    a: "如果希望保留原始语气与声音细节，原声加中文字幕更合适；如果不便持续阅读字幕，或需要在多任务状态下观看，普通话国语配音会更省力。",
  },
  {
    q: "找不到完全匹配的字幕时怎么办？",
    a: "可以先核对字幕的版本、片长与时间轴是否一致，再尝试在播放器中调整字幕延迟。若仍不匹配，通常需要换用与当前版本对应的字幕来源。",
  },
];

export const searchIntents = [
  {
    keyword: "嫂子的诱惑中文字幕",
    intent: "希望找到带中文对白文本的版本",
    note: "重点关注字幕形式（内嵌 / 外挂 / 在线）与语言标注。",
  },
  {
    keyword: "嫂子的诱惑国语版",
    intent: "希望观看中文配音版本",
    note: "重点确认对白是否已替换为国语，而非仅提供中文字幕。",
  },
  {
    keyword: "嫂子的诱惑中文配音",
    intent: "关注配音质量与配音语言",
    note: "留意是否标注普通话配音，以及配音与画面的贴合程度。",
  },
  {
    keyword: "嫂子的诱惑字幕在线",
    intent: "希望字幕可随播放同步加载",
    note: "关注是否支持切换语言轨道、调整字号与位置。",
  },
  {
    keyword: "嫂子的诱惑中字",
    intent: "快速确认是否提供中文字幕",
    note: "“中字”为简称，仍需核对字幕的具体形式。",
  },
  {
    keyword: "嫂子的诱惑普通话",
    intent: "希望对白为规范普通话",
    note: "常与国语配音同时出现，可作为判断是否便于听懂的线索。",
  },
];

export const relatedTopics = [
  {
    title: "家庭伦理题材",
    desc: "以家庭关系与人物情感为核心的题材，对白信息量较大，通常需要字幕辅助理解细节。",
    tags: ["对白密集", "适合中文字幕"],
  },
  {
    title: "情感剧情题材",
    desc: "情节推进依赖人物情绪与语气，保留原声更能体会细微的表演变化。",
    tags: ["语气重要", "推荐原声"],
  },
  {
    title: "都市生活题材",
    desc: "贴近日常的用语与场景，字幕阅读负担相对较低，适合对照观看。",
    tags: ["用语日常", "字幕友好"],
  },
  {
    title: "悬疑氛围题材",
    desc: "画面信息较密集，若不便频繁看字幕，中文配音版本能让注意力更集中于画面。",
    tags: ["画面密集", "适合配音"],
  },
];

export const stats = [
  { value: "6", label: "常见字幕与语言标注" },
  { value: "3", label: "字幕呈现形式" },
  { value: "2", label: "主流音轨选择" },
  { value: "5", label: "观看前检查要点" },
];